import React, { Component } from "react";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import CuentaSocioTransferencia from "../../../generico/CuentaSocioTransferencia";
import CuentaExterna from "../../../generico/Transferencia/CuentaExterna/CuentaExterna"
import TransferCuentasPropiasService from "../../../../services/transferencias/TransferCuentasPropiasService";
import AuthService from "../../../../services/login/auth.service";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons";
//TransferenciaXpressPaso1
export default class TransferenciaXpressPaso1 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  componentDidMount() {
    this.initData();
    this.verificaTienePin();
  }

  initData = () => {
    this.getInitialState();
    this.getCuentas();
    this.continuar.disabled = true;
    this.entidadSelected = undefined;
  };

  getInitialState = () => ({
    cuentasOrigen: "",
    monto: 0,
    itemSelected: { value: "-1", label: "--Seleccione--" },
    disableSgte: true,
    cuentaOrigenSelected: [],
    mensaje: undefined,
  });

  selectorValue = (dataFromChild, item) => {
    this.setState(
      {
        cuentaOrigenSelected: dataFromChild,
        cuentaDebito: dataFromChild.cuenta,
        detalleCuenta: dataFromChild.cuenta + " " + dataFromChild.denominacion,
        itemSelected: item,
      },
      this.enableNext
    );
  };

  enableNext() {
    const { itemSelected } = this.state;
    if (
      itemSelected.value !== undefined &&
      itemSelected.value !== "-1" &&
      this.entidadSelected !== undefined
    ) {
      this.continuar.disabled = false;
    } else {
      this.continuar.disabled = true;
    }

    this.checkCuentaDestino();
  }

  checkCuentaDestino() {
    if (this.entidadSelected !== undefined) {
      document.getElementById("radio_"+this.entidadSelected.id).checked = true;
    }
  }

  getCuentas() {
    trackPromise(
      TransferCuentasPropiasService.getCuentas("I").then((response) => {
        if(response.data.codigo !== "0" && response.data.mensaje === "SIN RESULTADOS"){
          Popup.queue(this.notifiPopup("Info", "No posee saldo suficiente en la(s) cuenta(s) de débito para continuar"));
        }
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);
        this.setState({ cuentasOrigen: jsonData.resultadoAH });
      })
    ).catch(function (error) {
      console.log(error);
    });
  }

  selectCuentaExterna = (data) => {
    this.entidadSelected = data;
    this.enableNext()
  };

  verificaTienePin() {
    AuthService.verificaTienePin().then((response) => {
      var data = JSON.stringify(response.data);
      var jData = JSON.parse(data);
    
      if (jData.codigo !== 0) {
        this.setState(
          {
            mensaje: jData.mensaje,
          },
          function () {
            this.mainDiv.style.display = "none";
          }
        );
      }
    });
  }

  render() {
    return (
      <div>
        <div>
          <div className="row">
            <div className="steps clearfix">
              <ul role="tablist">
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                      <span className="title_text current">
                        Selección de Cuentas
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">
                        Datos de Transferencia
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">
                        Datos de Verificación
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled last">
                  <span>
                    <div className="title">
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          {this.state.mensaje !== undefined && (
            <div className="row">
              <div className="col-md-6">
                <div className="callout callout-warning consideraciones">
                  <h5>Consideraciones</h5>
                  <p>{this.state.mensaje}</p>
                </div>
              </div>
            </div>
          )}

          <div ref={(div) => (this.mainDiv = div)}>
            <div className="row">
              <div className="col-md-5">
                <CuentaSocioTransferencia
                  selectorValue={this.selectorValue.bind(this)}
                  operacion="DEBITO"
                  tipoCuenta="AHORRO_VISTA"
                  items={this.state.cuentasOrigen}
                  itemSelected={this.state.itemSelected}
                />
              </div>
            </div>
            <br />
            <div className="row">
              <CuentaExterna intermediario="CABAL" selectCuentaExterna={this.selectCuentaExterna.bind(this)}/>
            </div>
            <hr />

            <div className="row">
              <div className="col-lg-10 col-md-8">
                  <label
                    className="input-label-bold-obligatorio">
                    (*) Campos Obligatorios
                    <br />
                  </label>
              </div>
              <div className="col-lg-2 col-md-4">
                  <button className="btn btn-cu-primary" ref={(button) => (this.continuar = button)}
                    onClick={() => {
                      this.props.returnDataPaso1(
                        this.state.cuentaOrigenSelected,
                        this.entidadSelected
                      );
                      this.nextStep.click();
                  }}>
                    Continuar <FontAwesomeIcon icon={faArrowRight} />
                  </button>
                  <button hidden ref={(a) => (this.nextStep = a)} className="btn btn-cu-primary" onClick={this.props.nextStep} ></button>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}